import React from 'react';
import WhyChooseUs from './WhyChooseUs';

const WhyChooseUsPage: React.FC = () => {
  return (
    <div className="py-20">
      <div className="container mx-auto px-4">
        <WhyChooseUs />
      </div>
    </div>
  );
};

export default WhyChooseUsPage;